import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { formatDecimal } from './formatDecimal';

export const useFormatDollars = () => {
  const intl = useIntl();
  return useCallback(
    (dollars: number, options?: { displayCentsWhenLessThanDollar?: boolean }): string => {
      if (options?.displayCentsWhenLessThanDollar && dollars < 1) {
        // We have to use Math.round() here to avoid the case described here
        // https://stackoverflow.com/questions/6486234/mysterious-calculation-error-when-multiply-by-100
        return `${Math.round(dollars * 100)}¢`;
      }

      const maximumFractionDigits = 2;
      const formattedPrice = formatDecimal(dollars, maximumFractionDigits);

      return intl.formatNumber(formattedPrice, {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits,
      });
    },
    [intl],
  );
};

export const convertCentsToDollars = (cents: number) => cents / 100;
